import React from 'react';

const SourcingAssistanceRequestModal = React.lazy(() =>
    import(
        /* webpackChunkName: "SourcingAssistanceRequestModal" */ './SourcingAssistanceRequestModal'
    )
);

export function SourcingAssistanceRequestModalLoader(props) {
    return (
        <React.Suspense fallback={null}>
            <SourcingAssistanceRequestModal {...props} />
        </React.Suspense>
    );
}
